var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 735.788,
    height: 448,
    viewBox: "0 0 735.788 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2524",
    "data-name": "Group 2524",
    transform: "translate(-461 -349)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_831",
    "data-name": "Rectangle 831",
    width: 104,
    height: 91,
    transform: "translate(786.894 650)",
    fill: "#364156"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_832",
    "data-name": "Rectangle 832",
    width: 104,
    height: 20,
    transform: "translate(786.894 650)",
    fill: "#212d40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_833",
    "data-name": "Rectangle 833",
    width: 446,
    height: 301,
    rx: 40,
    transform: "translate(616.894 349)",
    fill: "#364156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M921,618.907V389.027l.027-.027h416.795l.026.026V618.907l-.026.026H921.027Z",
    transform: "translate(-289.404 -25.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M921,414.192V389.027l.027-.027h416.795l.026.026v25.166l-.026.026H921.027Z",
    transform: "translate(-289.404 -25.166)",
    fill: "#d9e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M921,408.258V389.027l.027-.027h416.795l.026.026v19.232l-.026.026H921.027Z",
    transform: "translate(-289.404 -25.166)",
    fill: "#f28972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M1406.245,1379.318H1249A16.318,16.318,0,0,1,1265.318,1363h124.609a16.318,16.318,0,0,1,16.318,16.318Z",
    transform: "translate(-495.762 -637.947)",
    fill: "#212d40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2498",
    "data-name": "Group 2498",
    transform: "translate(643.464 400.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2493",
    "data-name": "Group 2493",
    transform: "translate(163.179 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_834",
    "data-name": "Rectangle 834",
    width: 25,
    height: 178,
    transform: "translate(0.251 -0.179)",
    fill: "#d9e8f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2494",
    "data-name": "Group 2494",
    transform: "translate(122.384 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_835",
    "data-name": "Rectangle 835",
    width: 25,
    height: 178,
    transform: "translate(0.046 -0.179)",
    fill: "#d9e8f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2495",
    "data-name": "Group 2495",
    transform: "translate(81.589 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_836",
    "data-name": "Rectangle 836",
    width: 25,
    height: 178,
    transform: "translate(-0.159 -0.179)",
    fill: "#d9e8f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2496",
    "data-name": "Group 2496",
    transform: "translate(40.795 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_837",
    "data-name": "Rectangle 837",
    width: 25,
    height: 178,
    transform: "translate(-0.365 -0.179)",
    fill: "#d9e8f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2497",
    "data-name": "Group 2497",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_838",
    "data-name": "Rectangle 838",
    width: 24,
    height: 178,
    transform: "translate(0.43 -0.179)",
    fill: "#d9e8f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2499",
    "data-name": "Group 2499",
    transform: "translate(806.642 420.576)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_839",
    "data-name": "Rectangle 839",
    width: 25,
    height: 157,
    transform: "translate(0.251 0.424)",
    fill: "#f25757"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2500",
    "data-name": "Group 2500",
    transform: "translate(765.848 485.477)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_840",
    "data-name": "Rectangle 840",
    width: 25,
    height: 93,
    transform: "translate(0.046 -0.477)",
    fill: "#f25757"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2501",
    "data-name": "Group 2501",
    transform: "translate(655.921 363.834)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M1288.817,389,1181.6,618.934H1130.04L1237.26,389Z",
    transform: "translate(-1076.84 -389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M1574.4,389l-107.22,229.934h-93.3L1481.1,389Z",
    transform: "translate(-1230.249 -389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M1119.592,389l-107.22,229.934H986.59L1093.813,389Z",
    transform: "translate(-986.59 -389)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2502",
    "data-name": "Group 2502",
    transform: "translate(725.053 432.815)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_841",
    "data-name": "Rectangle 841",
    width: 25,
    height: 145,
    transform: "translate(-0.159 0.185)",
    fill: "#f25757"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2503",
    "data-name": "Group 2503",
    transform: "translate(684.258 432.815)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_842",
    "data-name": "Rectangle 842",
    width: 25,
    height: 145,
    transform: "translate(-0.365 0.185)",
    fill: "#f25757"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2504",
    "data-name": "Group 2504",
    transform: "translate(643.464 489.185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_843",
    "data-name": "Rectangle 843",
    width: 24,
    height: 89,
    transform: "translate(0.43 -0.185)",
    fill: "#f25757"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_844",
    "data-name": "Rectangle 844",
    width: 187,
    height: 180,
    rx: 10,
    transform: "translate(848.894 400)",
    fill: "#d9e8f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2505",
    "data-name": "Group 2505",
    transform: "translate(495.861 741.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M1246.656,1425.543H564.271a9.271,9.271,0,0,1-9.271-9.271h0a9.272,9.272,0,0,1,9.271-9.271h682.384a9.272,9.272,0,0,1,9.272,9.271h0A9.272,9.272,0,0,1,1246.656,1425.543Z",
    transform: "translate(-555 -1407)",
    fill: "#b4dced"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M1322.848,1525.543H859.271a9.272,9.272,0,0,1-9.271-9.272h0a9.272,9.272,0,0,1,9.271-9.271h463.576a9.272,9.272,0,0,1,9.271,9.271h0A9.272,9.272,0,0,1,1322.848,1525.543Z",
    transform: "translate(-740.596 -1469.914)",
    fill: "#b4dced"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M1377.086,1466.271h0a9.272,9.272,0,0,1,9.272-9.271H1060a9.272,9.272,0,0,1,0,18.543h326.358A9.272,9.272,0,0,1,1377.086,1466.271Z",
    transform: "translate(-872.715 -1438.457)",
    fill: "#b4dced"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_845",
    "data-name": "Rectangle 845",
    width: 169,
    height: 104,
    transform: "translate(857.894 410)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2506",
    "data-name": "Group 2506",
    transform: "translate(946.641 428.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M1783.969,596.215a18.061,18.061,0,0,1,16.186-18.517l-.414-13.474a31.522,31.522,0,0,0-21.429,52.216l9.3-9.888A17.977,17.977,0,0,1,1783.969,596.215Z",
    transform: "translate(-1770.497 -564.144)",
    fill: "#a7d5f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M1873.866,592.351l13.537-.415a31.525,31.525,0,0,0-30.971-27.928l.414,13.474A18.066,18.066,0,0,1,1873.866,592.351Z",
    transform: "translate(-1824.563 -564.007)",
    fill: "#d9e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M1911.422,646.386h0l-13.457.413a17.983,17.983,0,0,1-3.659,11.462l9.839,9.253A31.4,31.4,0,0,0,1911.422,646.386Z",
    transform: "translate(-1848.39 -615.834)",
    fill: "#f28972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M1819.328,702.34a31.415,31.415,0,0,0,21.5-9.4l-9.813-9.229a18.058,18.058,0,0,1-25.323-.009l-9.224,9.808A31.427,31.427,0,0,0,1819.328,702.34Z",
    transform: "translate(-1786.838 -639.312)",
    fill: "#7fb2f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2507",
    "data-name": "Group 2507",
    transform: "translate(875.252 439.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M1634.742,594.967h-55.258a1.483,1.483,0,0,1-1.483-1.483h0a1.483,1.483,0,0,1,1.483-1.483h55.258a1.483,1.483,0,0,1,1.483,1.483h0A1.483,1.483,0,0,1,1634.742,594.967Z",
    transform: "translate(-1578 -592)",
    fill: "#d9e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M1644.013,624.967h-64.53a1.484,1.484,0,0,1-1.483-1.483h0a1.483,1.483,0,0,1,1.483-1.483h64.53a1.483,1.483,0,0,1,1.484,1.483h0A1.484,1.484,0,0,1,1644.013,624.967Z",
    transform: "translate(-1578 -610.874)",
    fill: "#d9e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M1644.013,654.967h-64.53a1.484,1.484,0,0,1-1.483-1.483h0a1.483,1.483,0,0,1,1.483-1.483h64.53a1.483,1.483,0,0,1,1.484,1.483h0A1.484,1.484,0,0,1,1644.013,654.967Z",
    transform: "translate(-1578 -629.748)",
    fill: "#d9e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M1644.013,684.967h-64.53a1.484,1.484,0,0,1-1.483-1.483h0a1.483,1.483,0,0,1,1.483-1.483h64.53a1.483,1.483,0,0,1,1.484,1.483h0A1.484,1.484,0,0,1,1644.013,684.967Z",
    transform: "translate(-1578 -648.622)",
    fill: "#d9e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M1610.265,714.967h-30.781a1.484,1.484,0,0,1-1.483-1.483h0a1.483,1.483,0,0,1,1.483-1.483h30.781a1.483,1.483,0,0,1,1.483,1.483h0A1.484,1.484,0,0,1,1610.265,714.967Z",
    transform: "translate(-1578 -667.497)",
    fill: "#d9e8f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2508",
    "data-name": "Group 2508",
    transform: "translate(783.149 416.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M1689.378,1363.986l.7,14.948,21.053-.14-6.807-16.141Z",
    transform: "translate(-1555.97 -1054.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M1527,1368.746l1.057,14.363-33.836.441,16.654-8.283,3.348-6.08Z",
    transform: "translate(-1433.188 -1057.948)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M1341.412,563.27s-4.573.5-8.948-8.138-3.569-10.414,1.9-11.184c3.2-.451.795-4.974-1.749-8.648-2.135-3.084,2.407-6.426,4.658-3.425a12.944,12.944,0,0,1,1.1,1.766c4,7.631,13.527,23.7,10.31,26.967A9.062,9.062,0,0,1,1341.412,563.27Z",
    transform: "translate(-1329.652 -530.701)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M1362.226,605.757l18.089,41.258,12.238-7.046-24.288-40.1Z",
    transform: "translate(-1350.145 -574.215)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M1547.795,604.59l-2.125,21.827c-.578,5.932,5.145,11.405,11.1,11.278s11.2-5.128,12.408-10.965-1.23-12.075-5.5-16.232A20.644,20.644,0,0,0,1547.795,604.59Z",
    transform: "translate(-1465.532 -577.147)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M1659.325,799.455l13.352,27.184a5.987,5.987,0,0,1-.9,6.6c-14.275,16.2-42.034,17.7-42.034,17.7l33.907-21.1L1650.1,807.113Z",
    transform: "translate(-1518.451 -699.785)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M1627.5,712.693c-15.018,7.441,6.66,44.637,25.807,58.579l11.049-11.068s-1.692-12.041-13.729-29.368C1635.414,708.938,1627.5,712.693,1627.5,712.693Z",
    transform: "translate(-1513.882 -645.045)",
    fill: "#4960a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M1570.439,672.36l-2.319,14.079,20.207-.828-2.484-16.895Z",
    transform: "translate(-1479.682 -617.532)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M1534.4,934.961l-3.611,159.506,22.271-1,8.226-135.029,25.682,134.828,22.827.483L1580.548,928.34Z",
    transform: "translate(-1456.196 -780.871)",
    fill: "#f28972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M1536.155,710.754s-3.963,85.858-2.38,87.583l53.392-1.462-3.335-76.226s.852-10.681-15.262-12.522S1536.155,710.754,1536.155,710.754Z",
    transform: "translate(-1457.839 -642.047)",
    fill: "#4960a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M1461.217,710.191s27.628,16.319,3.078,32.138l-44.045-17.2c-3.491-1.363-7.479-6.919-9.2-10.25l12.351-7.2Z",
    transform: "translate(-1380.863 -642.047)",
    fill: "#4960a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M1541.271,796.892l-6.359-2.483h0c-.873,21.82-1.817,49.148-1.412,56.577.17,1.228.277,1.914.277,1.914l23.567-.645Z",
    transform: "translate(-1457.839 -696.61)",
    fill: "#4e7ac7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M1689.583,860.711l3.588,6.018L1676.666,877h0s18.3-8.931,19.409-10.044-3.878-8.867-3.878-8.867Z",
    transform: "translate(-1547.972 -736.675)",
    fill: "#ffb188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M1362.226,615.752l21.865,39.1-3.758,2.19Z",
    transform: "translate(-1350.145 -584.21)",
    fill: "#ffb188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M1548.363,613.883l-.9-.069q-.9,9.223-1.8,18.446c-.52,5.337,4.062,10.3,9.325,11.151l.239.035.118.014C1544.285,637.607,1548.363,613.883,1548.363,613.883Z",
    transform: "translate(-1465.532 -582.991)",
    fill: "#ffb188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M1545.738,583.386a2.653,2.653,0,0,1-2.764-2.307,5.21,5.21,0,0,0-3.631-4.5c-8.106-2.037-11.91-13.521-6.623-19.994s17.3-5.037,20.913,2.5c1.507,3.143,5.183,4.588,8.617,5.184,3.39.588,6.963.659,10.038,2.189a7.534,7.534,0,0,1,3.342,10.034l-12.376,28.793c-8.474-.264-17.12-9.775-14.722-17.876a3.271,3.271,0,0,0-.907-3.364A2.48,2.48,0,0,0,1545.738,583.386Z",
    transform: "translate(-1455.875 -544.405)",
    fill: "#f27a5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M1578.467,1009.49l-20.37,135.29,12.253-.2Z",
    transform: "translate(-1473.375 -831.926)",
    fill: "#f25757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M1613.022,1009.49l37.237,135.073-11.555-.245Z",
    transform: "translate(-1507.931 -831.926)",
    fill: "#f25757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M1537.668,571.106c-.709-3.9.507-9.4,3.709-10.384,1.949-.6,4.459.521,5.934,2.225,3.49,4.034-.225,9.71,2.967,12.609,2.489,2.261,6.634.523,7.046,1.854.371,1.2-2.594,3.913-5.934,4.45C1545.758,582.766,1538.833,577.519,1537.668,571.106Z",
    transform: "translate(-1460.4 -549.485)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M1587.4,956.271H1534v-7.417L1587.4,947Z",
    transform: "translate(-1458.215 -792.611)",
    fill: "#364156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2513",
    "data-name": "Group 2513",
    transform: "translate(963.973 499.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2509",
    "data-name": "Group 2509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2691",
    "data-name": "Path 2691",
    d: "M1852.884,984.151c-18.19-25.02-58.359-92.242-18.859-96.789,9.8,1.251,18.036,13.454,27.617,12.343,35.836-12.865-33.036-98.057,15.669-93.349,37.9,3.663,17.916-28.473,30.326-45.958,13.98-14.38,36.044,4.848,36.215,24.253.9,22.231-11.093,41.662-24.424,56.088-23.97,22.454-5.549,29.936,9.208,51.474,15.633,39.658-36.073,47.8-44.936,77.054-1.725,5.578-2.074,11.869-4.9,16.792C1874.23,995.512,1861.353,995.8,1852.884,984.151Z",
    transform: "translate(-1817.23 -755.389)",
    fill: "#93cca7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2510",
    "data-name": "Group 2510",
    transform: "translate(48.24 17.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2692",
    "data-name": "Path 2692",
    d: "M1950.741,1011.358c-5.549-40.906-4.905-42.469,5.843-68.571,1.1-2.669,2.344-5.693,3.685-9.01,6.506-16.093,5.537-26.525,4.6-36.613-1.076-11.6-2.092-22.552,9.69-40.228a170.892,170.892,0,0,1,22.407-26.841c9.859-10.026,15.289-15.549,12.232-28.409l.361-.086c3.105,13.06-2.7,18.968-12.328,28.755a170.536,170.536,0,0,0-22.363,26.786c-11.709,17.567-10.7,28.458-9.629,39.988.94,10.132,1.912,20.609-4.627,36.786-1.341,3.318-2.587,6.343-3.686,9.012-10.712,26.015-11.354,27.572-5.818,68.38Z",
    transform: "translate(-1947.305 -801.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2511",
    "data-name": "Group 2511",
    transform: "translate(63.569 150.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    d: "M1989.01,1201.686l-.371-.006a49.306,49.306,0,0,1,25.927-40.263l.174.328a48.935,48.935,0,0,0-25.73,39.942Z",
    transform: "translate(-1988.639 -1161.417)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2512",
    "data-name": "Group 2512",
    transform: "translate(20.485 149.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2694",
    "data-name": "Path 2694",
    d: "M1887.152,1200.637a.7.7,0,0,1-.387-.109c-.7-.448-.552-2.176-.313-5.037.658-7.854,2.026-24.2-13.986-35.572l.215-.3c16.185,11.5,14.8,27.982,14.14,35.9-.2,2.44-.366,4.367.144,4.694.16.1.432.046.811-.166l.182.323A1.711,1.711,0,0,1,1887.152,1200.637Z",
    transform: "translate(-1872.467 -1159.618)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2695",
    "data-name": "Path 2695",
    d: "M1931.417,1378.239H1868A12.239,12.239,0,0,1,1880.239,1366h38.94a12.239,12.239,0,0,1,12.238,12.239Z",
    transform: "translate(-885.199 -639.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2518",
    "data-name": "Group 2518",
    transform: "translate(545.031 450.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2514",
    "data-name": "Group 2514",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    d: "M846,831.518c-5.581-11.536-27.593-6.614-32.033,5.407-3.657,9.9-16.959,14.783-26.152,9.6s-11.9-19.094-5.317-27.345c23.3-29.215,30.09-68.729,13.054-101.7a8.881,8.881,0,0,0-16.151.721c-3,7.5-17.417,3.724-20.239-3.845-2.9-7.777-4.488-16.2-5.635-24.445-2.058-14.786-3.146-30.059-9.5-43.567s-19.626-25.1-34.527-24.195-27.456,19.088-19.382,31.645c17.528,27.258,41.73,23.527,52.583,81.775,9.375,50.32-76.124,66.362,41.4,172.738a8.736,8.736,0,0,0,10.608.646C803.615,903.129,867.208,875.36,846,831.518Z",
    transform: "translate(-687.584 -622.099)",
    fill: "#7ebfb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2515",
    "data-name": "Group 2515",
    transform: "translate(25.737 18.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M808.032,814.855c-.629-32.869-14.472-69.991-25.973-95.345a448.076,448.076,0,0,0-25.077-47.648l.628-.395a448.846,448.846,0,0,1,25.12,47.726c11.533,25.42,25.413,62.648,26.044,95.646Z",
    transform: "translate(-756.982 -671.468)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2516",
    "data-name": "Group 2516",
    transform: "translate(73.05 173.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    d: "M916.973,1172.764a20.331,20.331,0,0,1-4.546-.5c-6.948-1.591-13.547-7.128-18.581-15.592-10.247-17.231-12.138-42.63-5.058-67.943l.714.2c-7.027,25.121-5.165,50.3,4.981,67.363,4.929,8.289,11.361,13.7,18.109,15.248,6.541,1.5,14.3-.49,22.442-5.748,7.554-4.879,15.253-12.532,21.677-21.549l.6.43C944.791,1162.253,929.477,1172.763,916.973,1172.764Z",
    transform: "translate(-884.559 -1088.73)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2517",
    "data-name": "Group 2517",
    transform: "translate(49.003 150.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M835.521,1074.3c-1.746-1.293-17.023-13.153-15.726-31.106a32.36,32.36,0,0,1,5.626-15.758l.614.416a31.617,31.617,0,0,0-5.5,15.395c-1.269,17.558,13.714,29.188,15.427,30.457Z",
    transform: "translate(-819.717 -1027.439)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M944.417,1379.239H881A12.239,12.239,0,0,1,893.238,1367h38.94a12.239,12.239,0,0,1,12.238,12.239Z",
    transform: "translate(-264.238 -640.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2519",
    "data-name": "Group 2519",
    transform: "translate(461 384.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M670.06,511.212c-21.782-7.287-51.277-5.079-73.06,19.285V463c21.782,24.364,51.277,26.572,73.06,19.285Z",
    transform: "translate(-546.563 -456.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M597,555v33.378c21.782-24.364,51.277-26.572,73.06-19.285V555Z",
    transform: "translate(-546.563 -514.297)",
    fill: "#d9e8f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_846",
    "data-name": "Rectangle 846",
    width: 44,
    height: 42,
    rx: 20,
    transform: "translate(100.894 20.306)",
    fill: "#f25757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_847",
    "data-name": "Rectangle 847",
    width: 5,
    height: 17,
    transform: "translate(45.894 32.306)",
    fill: "#f25757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_848",
    "data-name": "Rectangle 848",
    width: 21,
    height: 2,
    transform: "translate(114.894 25.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M773.563,648.861H768V614h24.106Z",
    transform: "translate(-654.146 -551.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    d: "M786.977,623.642,792.106,614H768v9.642Z",
    transform: "translate(-654.146 -551.416)",
    fill: "#d9e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    d: "M461,554.934V549l40.795,2.967Z",
    transform: "translate(-461 -510.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    d: "M474.247,492.845l2.967-5.139,33.846,22.967Z",
    transform: "translate(-469.334 -471.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    d: "M517.438,448.214l5.139-2.967L540.4,482.06Z",
    transform: "translate(-496.507 -445.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M520.845,607.3l-5.139-2.967,22.967-33.846Z",
    transform: "translate(-495.418 -524.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    d: "M476.214,587.6l-2.967-5.139,36.813-17.828Z",
    transform: "translate(-468.705 -520.358)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2520",
    "data-name": "Group 2520",
    transform: "translate(484.22 525.995)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_849",
    "data-name": "Rectangle 849",
    width: 77.881,
    height: 59.338,
    rx: 20,
    transform: "translate(0 27.316) rotate(-20.533)",
    fill: "#f2d5a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    d: "M530.519,859.664l44.131,22.01a4.08,4.08,0,0,0,5.613-2.146l18.488-46.582-22.767,42.042Z",
    transform: "translate(-527.957 -830.464)",
    fill: "#f28972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    d: "M593.944,832.48,534.9,854.593a7.407,7.407,0,0,0-4.384,4.485l39.7,18.066a7.439,7.439,0,0,0,9.823-3.679l18.7-41.106A7.367,7.367,0,0,0,593.944,832.48Z",
    transform: "translate(-527.957 -829.878)",
    fill: "#f2cb9b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2522",
    "data-name": "Group 2522",
    transform: "translate(1082.125 559.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    d: "M2204.8,985.35l-66.239-17.878a3.708,3.708,0,0,1-2.614-4.547l11.4-42.25a3.708,3.708,0,0,1,4.547-2.614l66.239,17.878a3.708,3.708,0,0,1,2.614,4.547l-11.4,42.25A3.708,3.708,0,0,1,2204.8,985.35Z",
    transform: "translate(-2135.819 -917.932)",
    fill: "#7fb2f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    d: "M2235.841,991.346l7.907,7.037a.742.742,0,0,1-.346,1.281l-10.374,2.1a.742.742,0,0,1-.864-.92l2.467-9.14A.742.742,0,0,1,2235.841,991.346Z",
    transform: "translate(-2196.417 -964.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2521",
    "data-name": "Group 2521",
    transform: "translate(8.039 7.777)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    "data-name": "Path 2714",
    d: "M2200.585,940.715l-36.377,43.192-6.713-1.812,36.377-43.192Z",
    transform: "translate(-2157.494 -938.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    d: "M2249.6,953.945l-36.377,43.192-17.383-4.692,36.377-43.192Z",
    transform: "translate(-2181.621 -945.414)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectB);
export default __webpack_public_path__ + "static/media/project-b.54c25e8323180cf0dd504ddfab57a19b.svg";
export { ForwardRef as ReactComponent };